﻿import * as React from "react";
import { Button } from "./Components";
import { NoTenancy } from "./NoTenancy";

interface ITenancy {
    country: string;
    lastAccess: Date;
    name: string;
    thumbnail: string;
    tenancyURL: string;
}

interface ITenancyRootProps {
    tenancies: ITenancy[];
}

// TODO: See if this interface can be removed
// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface ITenancyRootState {}

export class TenancyRoot extends React.Component<
    ITenancyRootProps,
    ITenancyRootState
> {
    private _openHandler(url: string): void {
        window.open(url, "_self");
    }

    private _getSuffix(dateNumber: number): string {
        switch (dateNumber) {
            case 1:
                return `st`;
            case 2:
                return `nd`;
            case 3:
                return `rd`;
            default:
                return `th`;
        }
    }

    private _getMonthName(monthNumber: number): string {
        const locale = "en-uk",
            objDate = new Date();

        objDate.setDate(1);
        objDate.setMonth(monthNumber);

        return objDate.toLocaleString(locale, { month: "long" });
    }

    private _formatLastAccess(date: Date): React.ReactNode {
        const dateNumber = date.getDate(),
            hours = date.getHours().toString().padStart(2, `0`),
            minutes = date.getMinutes().toString().padStart(2, `0`),
            month = this._getMonthName(date.getMonth()),
            year = date.getFullYear();

        const suffix = this._getSuffix(dateNumber);

        return (
            <React.Fragment>
                {dateNumber}
                <sup>{suffix}</sup> {month} {year} {hours}:{minutes}
            </React.Fragment>
        );
    }

    render(): React.ReactElement {
        let tenancyContent: React.ReactNode;

        if (this.props.tenancies.length === 0) {
            tenancyContent = <NoTenancy />;
        } else {
            tenancyContent = (
                <div className={`tenancy-list`}>
                    {this.props.tenancies.map((t, idx) => (
                        <div className={`info-card`} key={`tenancy-${idx}`}>
                            <div className={`image-info`}>
                                <img
                                    src={
                                        t.thumbnail == null ||
                                        t.thumbnail === ``
                                            ? `/Images/Placeholder_tenancy.png`
                                            : t.thumbnail
                                    }
                                />
                            </div>
                            <div className={`main-info`}>
                                <div className={`main-info`}>
                                    <div className={`tenancy-name`}>
                                        {t.name}
                                    </div>
                                    <div className={`tenancy-url`}>
                                        {t.tenancyURL}
                                    </div>
                                    <div>Country: {t.country}</div>
                                    <div>
                                        Last accessed:{" "}
                                        {t.lastAccess
                                            ? this._formatLastAccess(
                                                  new Date(t.lastAccess),
                                              )
                                            : ``}
                                    </div>
                                    <Button
                                        className={`big`}
                                        onClick={(): void =>
                                            this._openHandler(t.tenancyURL)
                                        }
                                        text={`Open`}
                                    />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            );
        }

        return (
            <div className={`tenancy-selector`}>
                <div className={`tenancy-selector-top-bar`}>
                    <div className={`title`}>Tenancy Selection</div>
                    <div>
                        <button
                            className={`button`}
                            onClick={(): void => {
                                location.href = `/Account/Logout`;
                            }}
                        >
                            Log Out
                            <img
                                className={`button-icon`}
                                src={`/Images/LogoutSectionIcon.svg`}
                            />
                        </button>
                        <button
                            className={`button`}
                            onClick={(): void => {
                                location.href = `/EditProfile?ReturnURL=${window.location.pathname}`;
                            }}
                        >
                            Edit Profile
                        </button>
                    </div>
                </div>
                {tenancyContent}
            </div>
        );
    }
}
